import React from "react";
import { withRouter } from "react-router";
import AgregarCadete from "./AgregarCadete";
const EditarCadete = props => {
    return <AgregarCadete editar={true} />;
};

export default withRouter(EditarCadete);
